'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useSchemes } from '@personly/libs-providers';
import { SrcSet } from '@/libs/srcSets';
interface Props {
  priority?: boolean;
  srcSets: Record<string, SrcSet>;
  className?: string;
  sizes?: string;
}
const Picture = t0 => {
  const $ = _c(14);
  const {
    priority: t1,
    srcSets,
    className,
    sizes
  } = t0;
  const priority = t1 === undefined ? false : t1;
  const {
    displaySchemeHandle,
    schemeHandle
  } = useSchemes();
  let t2;
  if ($[0] !== schemeHandle || $[1] !== srcSets) {
    t2 = schemeHandle === "SYSTEM" && Object.keys(srcSets).map(schemeHandle_0 => <source key={`${schemeHandle_0}-${srcSets[schemeHandle_0].url}`} srcSet={srcSets[schemeHandle_0].url} media={`(prefers-color-scheme: ${schemeHandle_0.toLowerCase()})`} width={srcSets[schemeHandle_0].width} height={srcSets[schemeHandle_0].height} />);
    $[0] = schemeHandle;
    $[1] = srcSets;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = srcSets[displaySchemeHandle];
  const t4 = srcSets[displaySchemeHandle];
  const t5 = srcSets[displaySchemeHandle];
  const t6 = srcSets[displaySchemeHandle];
  let t7;
  if ($[3] !== className || $[4] !== priority || $[5] !== sizes || $[6] !== t3.alt || $[7] !== t4.height || $[8] !== t5.url || $[9] !== t6.width) {
    t7 = <Image alt={t3.alt} className={className} height={t4.height} priority={priority} sizes={sizes} src={t5.url} width={t6.width} />;
    $[3] = className;
    $[4] = priority;
    $[5] = sizes;
    $[6] = t3.alt;
    $[7] = t4.height;
    $[8] = t5.url;
    $[9] = t6.width;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t7) {
    t8 = <picture>{t2}{t7}</picture>;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default Picture;